import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: css({
        display: 'flex',
        padding: '20px',
        flexDirection: 'column',
        justifyContent: 'space-between',
        order: 0,
        border: isHosTheme
            ? `0.5px solid ${theme.palette.secondary.dark}`
            : `1px solid ${theme.palette.grey[600]}`,
        [theme.breakpoints.up('lg')]: {
            flexDirection: 'row',
            padding: '25px',
            order: 1,
        },
        ...(isHosTheme && {
            borderRadius: theme.custom.borderRadius[23],
            background: theme.palette.common.white,
        }),
    }),
    infoWrapper: css({
        display: 'flex',
        gap: '20px',
        flexDirection: 'column',
        [theme.breakpoints.up('lg')]: {
            flexDirection: 'row',
        },
    }),
    info: css({
        display: 'flex',
        flexDirection: 'column',
        gap: isHosTheme ? '10px' : '6px',
    }),
};
